import { type RouteProps, Route, Redirect } from 'react-router-dom'
import { useAuth } from 'api'
import { paths } from 'constants/paths'

export function PrivateRoute(props: RouteProps) {
  const { data, isFetching } = useAuth()

  if (isFetching) return null

  if (data?.isAnonymous) return <Redirect to={paths.root} />

  return <Route {...props} />
}
